import Vue from 'vue'
import Vuex from 'vuex'

import app from '@/store/app'
import login from '@/store/login'
import snackbar from '@/store/snackbar'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app,
    login,
    snackbar,
  },
})
